import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { isFirefox } from 'react-device-detect';
import { useHasSupportedVideoCodec } from '../../hooks/useHasSupportedVideoCodec';
import { BroadcastService } from '../../services/broadcast/BroadcastService';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { MediaService } from '../../services/media/MediaService';
import { BroadcasterCanvas } from '../BroadcasterCanvas';
import { Button } from '../Button';
import { FullscreenButton } from '../FullscreenButton';
import { BroadcasterViewMobileHud } from '../huds/BroadcasterViewMobileHud';
import { LoadingIndicator } from '../LoadingIndicator';
import { CodecNotSupported, FirefoxNotSupported } from '../NotSupportedMessage';
import { Stage } from '../Stage';
import { PluginComponentContainer } from '../shared/PluginComponentContainer';
import { PluginOverlayContainer } from '../shared/PluginOverlayContainer';
import { VideoDisplay } from '../VideoDisplay';
import { VideoOverlayDisplay } from '../VideoOverlayDisplay';
import { MobileView } from '../views/MobileView';
import { BlockedPermissions } from '../views/View';
export function BroadcasterViewMobile() {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const [viewElement, setViewElement] = useState(null);
    const browserVideoCodecSupported = useHasSupportedVideoCodec();
    // Service-based UI
    // !! Notice the naming convention for the state variables to reduce the cognitive load
    // when reading the code. There is no need to remember where each state variable is coming from.
    // !!
    const broadcastOutputServiceRunning = BroadcastService.getOutput().useServiceRunning();
    // Media service and its reactive state
    const mediaService = MediaService.getNotificationInterface();
    const mediaOutputMicrophonePermissioned = MediaService.getOutput().useMicrophonePermissioned();
    const mediaOutputCameraPermissioned = MediaService.getOutput().useCameraPermissioned();
    const mediaOutputMediaStreamData = MediaService.getOutput().useMediaStreamData();
    // Event handlers
    const onRequestMediaPermissionsButtonClicked = () => {
        mediaService.notifyMediaPermissionsRequested({
            audio: true,
            video: true,
        });
    };
    useEffect(() => {
        mediaService.notifyStartCaptureRequested();
        return () => {
            mediaService.notifyStopCaptureRequested();
        };
    }, [mediaService]);
    if (isFirefox) {
        return _jsx(FirefoxNotSupported, {});
    }
    if (browserVideoCodecSupported === false) {
        return _jsx(CodecNotSupported, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(LoadingIndicator, { loading: !broadcastOutputServiceRunning }), _jsxs(MobileView, { innerRef: setViewElement, children: [_jsx(Stage, { children: mediaOutputMicrophonePermissioned ||
                            mediaOutputCameraPermissioned ||
                            mediaOutputMediaStreamData.isSharingScreen ? (_jsx(VideoDisplay, { component: _jsx(BroadcasterCanvas, {}), fit: "cover" })) : (_jsx(BlockedPermissions, { children: _jsx(Button, { type: "button", kind: "secondary", size: "big", padding: "normal", onClick: onRequestMediaPermissionsButtonClicked, children: "Allow microphone and\u00A0camera" }) })) }), _jsx(VideoOverlayDisplay, { fit: "cover", children: _jsx(BroadcasterViewMobileHud, { activeBroadcast: activeBroadcast, fullscreenButton: _jsx(FullscreenButton, { element: viewElement }) }) }), _jsx(PluginOverlayContainer, { slotId: "overlay" }), _jsx(PluginComponentContainer, { slotId: "components" })] })] }));
}
